import { getSurveyZipcodeFromHomeAddress } from "@utils/billingData";
import { updateSessionState } from "src/pageDefinitions/session";
import { shouldShowProactiveHealthFlow } from "src/utils/userSegment/features";
import { updateCurrentAnswers } from "src/utils/redux/slices/currentAnswers";
import { addSurveyAnswers } from "src/utils/redux/slices/surveyAnswers";
import { getZipcodeEligibilityStatus } from "src/utils/zipcodeEligibility";
import { ActionHandler } from "..";
import { getPageSetSurvey } from "./util";

export const prefillZipcodeFromBillingHomeAddress: ActionHandler = ({
  store,
  pageSet,
  page,
}) => {
  const { surveyNameSpace } = getPageSetSurvey(pageSet, page);
  const surveyZipcode = getSurveyZipcodeFromHomeAddress(
    store.getState().billingData?.homeAddress?.data
  );

  if (!surveyZipcode || !surveyNameSpace) {
    return;
  }

  const answers = { zipcode: surveyZipcode };
  store.dispatch(addSurveyAnswers(answers));
  store.dispatch(
    updateCurrentAnswers({
      namespace: surveyNameSpace,
      answers,
    })
  );
  updateSessionState("browser", {
    zipcodeEligibilityStatus: getZipcodeEligibilityStatus(),
    wasProactiveHealthEligible: shouldShowProactiveHealthFlow(),
  });
};
